import React from 'react';
import { Table, AutoSizer } from 'react-virtualized';
import styles from 'styles/table.css';
import ImportantIcon from 'static/images/icons/alert-circle.svg';
import AsyncContent, { LOADER_SIZE } from '../AsyncContent/AsyncContent';
import { getStripeRowStyle } from './utils';

const PagingTable = ({
  rows,
  wrapperClassName,
  tableClassName = styles.table,
  headerClassName = styles.headerWrapper,
  gridClassName = styles.tableBody,
  tableHeight,
  rowCount,
  noDataText = 'No data found',
  enableLoader,
  showLoader,
  loadingPage,
  error,
  ...props
}) => {
  const defaultWidth = 200;
  const defaultHeight = 200;
  return (
    <div className={wrapperClassName}>
      <AutoSizer>
        {({ height, width }) => {
          return (
            <Table
              width={width || defaultWidth}
              height={tableHeight || height || defaultHeight}
              className={tableClassName}
              headerClassName={headerClassName}
              gridClassName={gridClassName}
              rowClassName={getStripeRowStyle}
              rowCount={rowCount || rows.length}
              rowGetter={({ index }) => rows[index]}
              {...props}
            />
          );
        }}
      </AutoSizer>
      {enableLoader && loadingPage === 1 && (
        <AsyncContent
          isFetching={showLoader}
          className={styles.loadingOverlay}
          loader="ecg"
        />
      )}
      {enableLoader && loadingPage !== 1 && (
        <AsyncContent
          isFetching={showLoader}
          className={styles.loadingBottomOverlay}
          size={LOADER_SIZE.MEDIUM}
        />
      )}

      {error && !showLoader && (
        <div className={styles.noDataOverlay}>
          <div className={styles.errorContent}>
            <ImportantIcon />
            {error.message}
          </div>
        </div>
      )}
      {!error && !showLoader && rows && rows.length === 0 && (
        <div className={styles.noDataOverlay}>
          <div className={styles.noDataText}>{noDataText}</div>
        </div>
      )}
    </div>
  );
};
export default PagingTable;



// WEBPACK FOOTER //
// ./src/views/components/Table/PagingTable.jsx